import axios from 'axios';
import {API_ROOT, SM_URL} from '../app/utils';

export function postEngagement(id, value) {

	return function (dispatch, getState) {
		axios.post(SM_URL + '/api/products/gsc/engagement', {
			'event': id,
			'value': value
		},{
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'token ' + (getState().profileReducer.getSmUser !== null ? getState().profileReducer.getSmUser[1]  : getState().profileReducer.userToken)
			}
		}).then( response => {
			dispatch({
				type: "ENGAGEMENT_API",
				payload: response.data
			});
		}).finally(() => {
			if(id === 59){
				// Upgrade to Business: use /api/payment so production CDN proxies to Jetty
				// (plain /payment/* is served as SPA and bounces). Same hop as Buy.
				// API_ROOT keeps local :3000 → Tomcat :8080.
				window.location.href = API_ROOT + '/api/payment/new'
			}
		})
	}

}
